import { Autocomplete, Button, Stack, TextField } from '@mui/material';
import axios from '../../util/Axios';

import { useState } from 'react';
const DESCRIPTION_OPTIONS = ['Informed consent', 'Discharge note', 'CT Scan image', 'MRI image'];

export function AttachmentUpload({ close, testId }) {
  const [description, setDescription] = useState('');
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const handleFileUpload = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedFile = e.target.files[0];
    setFileName(selectedFile.name);
    setFile(selectedFile);
  };

  const uploadFile = () => {
    const formData = new FormData();
    formData.append('file', file); // file is the file object
    formData.append('testId', testId);
    formData.append('description', description);

    axios('attachments/', {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    }).then(() => close());
  };

  return (
    <Stack direction="row" spacing={2}>
      <Autocomplete onInputChange={(_, newValue) => setDescription(newValue)} size="small" sx={{ width: '250px' }} id="free-solo-demo" freeSolo options={DESCRIPTION_OPTIONS} renderInput={(params) => <TextField {...params} required label="Description" />} />
      <Button variant="outlined" size="small" component="label" sx={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {fileName || 'Choose File'}
        <input type="file" hidden onChange={handleFileUpload} />
      </Button>

      <Button disabled={!(fileName && description)} variant="contained" onClick={uploadFile}>
        {' '}
        Save
      </Button>

      <Button onClick={close}> Cancel</Button>
    </Stack>
  );
}
